var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/view_cart_white.ba4c4874.png","uri@2x": __webpack_public_path__ + "static/media/view_cart_white.eae990a5.png","uri@3x": __webpack_public_path__ + "static/media/view_cart_white.45b66120.png",
    width: 18,
    height: 21
});